import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { CurrencyProvider } from './contexts/CurrencyContext';
import AccessibilityControls from './components/base/AccessibilityControls';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <CurrencyProvider>
        <AppRoutes />
        <AccessibilityControls />
      </CurrencyProvider>
    </BrowserRouter>
  );
}

export default App;